import { GridScorecard } from "@/grid/components/GridScorecard";
import { isDepartmentId } from "@/grid/config/registry";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

export function DisplayGridPage() {
  const { departmentId = "sales" } = useParams<{ departmentId: string }>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  if (!isDepartmentId(departmentId)) {
    return <Navigate to="/display/sales" replace />;
  }

  if (!token) {
    return (
      <div className="grid-bg flex min-h-dvh items-center justify-center p-6">
        <p className="max-w-md text-center text-sm text-[var(--color-muted-foreground)]">
          Missing display token. Add <code className="text-xs">?token=...</code> to the URL.
        </p>
      </div>
    );
  }

  return <GridScorecard departmentId={departmentId} displayToken={token} />;
}
